@if (sinConsultaActiva) {
  <div class="empty-state">
    <!-- <mat-icon>event_busy</mat-icon> -->
    <h2>No hay ninguna consulta activa</h2>
    <p>Selecciona un paciente en espera desde el inicio para comenzar una consulta.</p>

    <button mat-flat-button class="add-boton" routerLink="/inicio">
      Volver a inicio <mat-icon>home</mat-icon>
    </button>
  </div>
} @else {
  <div class="page">
    <!-- INCIO DATOS DE PACIENTE -->
    <div class="resumen">
      <!-- Fila 1: paciente + temporizador -->
      <div class="resumen-fila">
        <div class="paciente">
          <div class="icon-box"><mat-icon>person</mat-icon></div>

          <div class="paciente-info">
            <h1>{{ paciente.nombre }} {{ paciente.apellido }} {{ paciente.segundoApellido }}</h1>
            <p>
              @if (paciente.genero === 'masculino') {
                Masculino ·
              }
              @if (paciente.genero === 'femenino') {
                Femenino ·
              }
              {{ obtenerEdad(paciente) }} años ({{ paciente.fechaNacimiento | date: 'dd/MM/yyyy' }})
              · Alergias: {{ paciente.expediente?.alergias || 'No registradas' }}
            </p>
          </div>
        </div>

        <div class="acciones-resumen">
          <!-- HISTORIA CLINICA -->

          <!-- HISTORIA CLINICA -->
          <button
            mat-icon-button
            type="button"
            class="accion-resumen"
            [class.pendiente]="historiaClinicaIncompleta"
            [matTooltip]="
              historiaClinicaIncompleta ? 'Historia clínica pendiente' : 'Ver historia clínica'
            "
            aria-label="Ver historia clínica"
            (click)="abrirHistoriaClinica()"
          >
            <mat-icon class="material-symbols-outlined">history_edu</mat-icon>
          </button>
          <!-- HISTORIAL DE SIGNOS VITALES  -->

          <button
            mat-icon-button
            type="button"
            class="accion-resumen"
            matTooltip="Ver historial de signos vitales"
            aria-label="Historial de signos vitales"
            (click)="abrirHistorialSignosVitales()"
          >
            <mat-icon class="material-symbols-outlined">monitor_heart</mat-icon>
          </button>

          <button
            mat-icon-button
            type="button"
            class="accion-resumen"
            matTooltip="Ver historial de signos vitales"
            aria-label="Historial de signos vitales"
            (click)="abrirGragicaSignosVitales()"
          >
            <mat-icon class="material-symbols-outlined">monitor_heart</mat-icon>
          </button>

          <!-- RESUMEN DE ESTUDIOS SOLICITADOS  -->

          <button
            mat-icon-button
            type="button"
            class="accion-resumen"
            matTooltip="Ver resumen de estudios"
            aria-label="Ver resumen de estudios"
            (click)="abrirResumenEstudios(paciente)"
          >
            <mat-icon class="material-symbols-outlined">biotech</mat-icon>
          </button>

          <!-- RESUMEN DE CONSULTAS PASADAS -->

          <button
            mat-icon-button
            type="button"
            class="accion-resumen"
            matTooltip="Ver historial de recetas"
            aria-label="Ver historial de recetas"
            (click)="abrirResumenReceta(paciente)"
          >
            <mat-icon class="material-symbols-outlined">event_note</mat-icon>
          </button>
        </div>

        <div class="temporizador-consulta" [class.tiempo-finalizado]="tiempoCumplido">
          <div class="spinner-container">
            <mat-progress-spinner
              mode="determinate"
              [value]="progresoConsulta"
              diameter="40"
              strokeWidth="5"
            >
            </mat-progress-spinner>
            <div class="spinner-tiempo">
              <strong>{{ tiempoRestanteFormato }}</strong>
            </div>
          </div>

          <!-- <div class="temporizador-info">
            @if (!tiempoCumplido) {
              <strong>Tiempo de consulta</strong>
            } @else {
              <strong>Tiempo cumplido</strong>
            }
          </div> -->
        </div>

        <button
          mat-icon-button
          type="button"
          class="toggle-resumen"
          (click)="resumenAbierto = !resumenAbierto"
          [matTooltip]="resumenAbierto ? 'Ocultar signos vitales' : 'Mostrar signos vitales'"
        >
          <mat-icon>{{ resumenAbierto ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>

      <!-- Fila 2: signos vitales en chips -->
      @if (resumenAbierto) {
        @if (!ultimoSignosVitales) {
          <p class="sin-datos">Este paciente no tiene signos vitales registrados.</p>
        } @else {
          <div class="signos-chips">
            <span class="chip"
              ><small
                >Peso:
                <b>{{
                  ultimoSignosVitales.peso !== null ? ultimoSignosVitales.peso + ' kg' : '—'
                }}</b></small
              ></span
            >
            <span class="chip"
              ><small
                >Talla:
                <b>{{
                  ultimoSignosVitales.estatura !== null ? ultimoSignosVitales.estatura + ' m' : '—'
                }}</b></small
              ></span
            >
            <span class="chip"
              ><small
                >FC:
                <b>{{
                  ultimoSignosVitales.frecuenciaCardiaca !== null
                    ? ultimoSignosVitales.frecuenciaCardiaca + ' lpm'
                    : '—'
                }}</b></small
              ></span
            >
            <span class="chip"
              ><small
                >FR:
                <b>{{
                  ultimoSignosVitales.frecuenciaRespiratoria !== null
                    ? ultimoSignosVitales.frecuenciaRespiratoria + ' RPM'
                    : '—'
                }}</b></small
              ></span
            >
            <span class="chip"
              ><small
                >SatO2:
                <b>{{
                  ultimoSignosVitales.saturacionOxigeno !== null
                    ? ultimoSignosVitales.saturacionOxigeno + ' %'
                    : '—'
                }}</b></small
              ></span
            >
            <span class="chip"
              ><small
                >Temp:
                <b>{{
                  ultimoSignosVitales.temperatura !== null
                    ? ultimoSignosVitales.temperatura + ' °C'
                    : '—'
                }}</b></small
              ></span
            >
            <span class="chip">
              <small
                >TA:
                <b>{{
                  ultimoSignosVitales.presionSistolica !== null &&
                  ultimoSignosVitales.presionDiastolica !== null
                    ? ultimoSignosVitales.presionSistolica +
                      '/' +
                      ultimoSignosVitales.presionDiastolica +
                      ' mmHg'
                    : '—'
                }}</b></small
              >
            </span>
            <span
              class="chip chip-obs"
              [matTooltip]="ultimaObservacionSignosVitales || 'Sin observaciones'"
            >
              <small
                >Observaciones:
                <b>{{ ultimaObservacionSignosVitales || 'Sin observaciones' }}</b></small
              >
            </span>
          </div>
        }
      }
    </div>

    @if (consultaActiva && historiaClinicaIncompleta) {
      <div class="aviso-historia">
        <mat-icon class="material-symbols-outlined">assignment_late</mat-icon>

        <span>
          {{
            esPrimeraConsulta
              ? 'Es la primera consulta de este paciente. Registra su historia clínica durante esta consulta.'
              : 'La historia clínica de este paciente está incompleta. Actualízala durante esta consulta.'
          }}
        </span>

        <button
          mat-flat-button
          type="button"
          class="add-boton add-boton--flexible"
          (click)="abrirHistoriaClinica()"
        >
          Completar historia clínica
        </button>
      </div>
    }

    <mat-stepper #stepper class="consulta-stepper" (selectionChange)="cambioPaso($event)">
      <!-- =========================
            EXPLORACIÓN
        ========================= -->
      <mat-step [stepControl]="exploracionForm">
        <form [formGroup]="exploracionForm">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined">conditions</mat-icon>
              Exploración
            </div>
          </ng-template>

          <div class="section-card2">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined">conditions</mat-icon>

              <div>
                <h2>Exploración clínica</h2>
                <p>Registre la información obtenida durante la consulta</p>
              </div>
            </div>

            <div class="form-grid">
              <mat-form-field appearance="outline" class="full">
                <mat-label> Padecimiento actual </mat-label>

                <textarea
                  matInput
                  rows="3"
                  placeholder="Describa el motivo de consulta..."
                  formControlName="padecimiento"
                >
                </textarea>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full">
                <mat-label> Hallazgos en exploración física </mat-label>

                <textarea
                  matInput
                  rows="3"
                  placeholder="Describa los hallazgos encontrados..."
                  formControlName="exploracionFisica"
                >
                </textarea>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full">
                <mat-label> Impresión diagnóstica </mat-label>

                <textarea
                  matInput
                  rows="3"
                  placeholder=" Impresión diagnóstica..."
                  formControlName="diagnostico"
                >
                </textarea>
              </mat-form-field>
            </div>
            <div class="boton">
              <button
                mat-flat-button
                type="button"
                class="add-boton"
                (click)="guardarExploracion()"
              >
                Siguiente <mat-icon iconPositionEnd>arrow_forward</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </mat-step>

      <!-- =========================
            ANALISIS CLINICO
        ========================= -->

      <mat-step [stepControl]="analisisClinicoForm">
        <form [formGroup]="analisisClinicoForm">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined">clinical_notes</mat-icon>
              Análisis clínico
            </div>
          </ng-template>

          <div class="section-card2">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined">clinical_notes</mat-icon>

              <div>
                <h2>Análisis clínico</h2>
                <p>Registre la información obtenida de los análisis</p>
              </div>

              <button
                mat-flat-button
                type="button"
                class="add-boton add-boton--derecha"
                (click)="abrirDialogAnalisis()"
              >
                <mat-icon>add</mat-icon>
                Agregar análisis
              </button>
            </div>

            <div class="lista-medicamentos">
              <h2>Análisis registrados</h2>

              @if (analisisAgregados.length === 0) {
                <p class="sin-datos">No se han agregado análisis en esta consulta.</p>
              }

              @for (analisis of analisisAgregados; track $index) {
                <div class="medicamento-item">
                  <div class="med-info">
                    <div class="med-header">
                      <mat-icon>biotech</mat-icon>
                      <strong>{{ $index + 1 }}. {{ analisis.estudio }}</strong>
                    </div>

                    <div class="med-detalles analisis-detalles">
                      <span class="col-resumen"><b>Resumen:</b> {{ analisis.resumen }}</span>
                      <span class="col-archivo"
                        ><b>Archivo:</b> {{ analisis.archivoNombre || '—' }}</span
                      >
                    </div>
                  </div>

                  <div class="med-actions">
                    @if (consultaActiva && analisis.editable) {
                      <button
                        mat-icon-button
                        class="edit-btn"
                        type="button"
                        (click)="editarAnalisis($index)"
                        matTooltip="Editar análisis"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        class="delete-btn"
                        type="button"
                        (click)="eliminarAnalisis($index)"
                        matTooltip="Eliminar análisis"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }

              <div class="acciones-paso">
                <button mat-flat-button type="button" class="add-boton" matStepperPrevious>
                  <mat-icon>arrow_back</mat-icon>
                  Anterior
                </button>

                <button mat-flat-button type="button" class="add-boton" matStepperNext>
                  Siguiente
                  <mat-icon iconPositionEnd>arrow_forward</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-step>

      <!-- =========================
            RECETAS
        ========================= -->
      <mat-step [stepControl]="recetaForm">
        <form [formGroup]="recetaForm">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined">prescriptions</mat-icon>
              Recetas
            </div>
          </ng-template>

          <div class="section-card2">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined">prescriptions</mat-icon>

              <div>
                <h2>Tratamiento indicado</h2>
                <p>Agregue la información que se incluirá en la receta</p>
              </div>

              <span>
                Folio:
                {{ creandoReceta ? 'Generando...' : folioReceta || '—' }}
              </span>
            </div>

            <div class="form-grid">
              <mat-form-field appearance="outline" class="full">
                <mat-label> Diagnostico </mat-label>
                <input
                  matInput
                  placeholder="Ej. Infección intestinal"
                  formControlName="diagnostico"
                  required
                />
              </mat-form-field>

              <div class="lista-medicamentos full">
                <div class="lista-header">
                  <h2>Medicamentos agregados</h2>

                  <button
                    mat-flat-button
                    type="button"
                    class="add-boton"
                    (click)="abrirDialogMedicamento()"
                  >
                    <mat-icon>add</mat-icon>
                    Agregar medicamento
                  </button>
                </div>

                @if (medicamentosAgregados.length === 0) {
                  <p class="sin-datos">No se han agregado medicamentos en esta consulta.</p>
                }

                @for (med of medicamentosAgregados; track $index) {
                  <div class="medicamento-item">
                    <div class="med-info">
                      <div class="med-header">
                        <mat-icon> medication </mat-icon>

                        <strong> {{ $index + 1 }}. {{ med.medicamento }} </strong>
                      </div>

                      <div class="med-detalles">
                        <span> <b>Dosis:</b> {{ med.dosis }} </span>

                        <span> <b>Frecuencia:</b> {{ med.frecuencia }} </span>

                        <span> <b>Duración:</b> {{ med.duracion }} </span>
                      </div>
                    </div>

                    <div class="med-actions">
                      <!-- Editar -->
                      <button
                        mat-icon-button
                        class="edit-btn"
                        type="button"
                        (click)="editarMedicamento($index)"
                        matTooltip="Editar medicamento"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>

                      <!-- Eliminar -->
                      <button
                        mat-icon-button
                        class="delete-btn"
                        type="button"
                        (click)="eliminarMedicamento($index)"
                        matTooltip="Eliminar medicamento"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>

              <h2 class="full">Indicaciones generales y observaciones</h2>

              <!-- Posologías guardadas -->
              <mat-form-field appearance="outline" class="full">
                <mat-label>Opciones de indicaciones generales</mat-label>

                <mat-select multiple (selectionChange)="seleccionarIndicaciones($event.value)">
                  @for (indicacion of indicacionesDisponibles; track $index) {
                    <mat-option [value]="indicacion">
                      {{ indicacion.nombre }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <!-- Posología editable -->
              <mat-form-field appearance="outline" class="full">
                <mat-label>Indicaciones generales</mat-label>

                <textarea
                  matInput
                  rows="3"
                  placeholder="Indicaciones..."
                  formControlName="indicaciones"
                  (focus)="iniciarVinyetas('indicaciones')"
                  (keydown.enter)="agregarVinyeta($event, 'indicaciones')"
                >
                </textarea>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full">
                <mat-label>Observaciones</mat-label>

                <textarea
                  matInput
                  rows="3"
                  placeholder="Observaciones..."
                  formControlName="observaciones"
                  (focus)="iniciarVinyetas('observaciones')"
                  (keydown.enter)="agregarVinyeta($event, 'observaciones')"
                >
                </textarea>
              </mat-form-field>

              <!-- ANALISIS SOLICITADOS  -->

              <!-- estudios guardados -->

              <div class="lista-medicamentos full">
                <div class="lista-header">
                  <h2>Estudios agregados</h2>

                  <button
                    mat-flat-button
                    type="button"
                    class="add-boton"
                    (click)="abrirDialogEstudios()"
                  >
                    <mat-icon>add</mat-icon>
                    Agregar estudios
                  </button>
                </div>

                @if (estudiosAgregados.length === 0) {
                  <p class="sin-datos">No se han agregado estudios en esta consulta.</p>
                }

                @for (estudio of estudiosAgregados; track $index) {
                  <div class="medicamento-item">
                    <div class="med-info">
                      <div class="med-header">
                        <mat-icon class="material-symbols-outlined"> biotech </mat-icon>

                        <strong> {{ $index + 1 }}. {{ estudio.nombre }} </strong>
                      </div>

                      <div class="med-detalles">
                        <span> <b>Indicación:</b> {{ estudio.indicaciones }} </span>
                      </div>
                    </div>

                    <div class="med-actions">
                      <!-- Editar -->
                      <button
                        mat-icon-button
                        class="edit-btn"
                        type="button"
                        (click)="editarEstudio($index)"
                        matTooltip="Editar estudio"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>

                      <!-- Eliminar -->
                      <button
                        mat-icon-button
                        class="delete-btn"
                        type="button"
                        (click)="eliminarEstudio($index)"
                        matTooltip="Eliminar estudio"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>

              <h2 class="full">Plan de seguimiento (opcional)</h2>

              <mat-form-field appearance="outline">
                <mat-label>Próxima cita</mat-label>
                <input
                  matInput
                  readonly
                  placeholder="Selecciona una fecha"
                  formControlName="proximaCita"
                  [matDatepicker]="pickerCita"
                  [min]="fechaActual"
                  (click)="pickerCita.open()"
                />
                @if (recetaForm.get('proximaCita')?.value) {
                  <button
                    matIconSuffix
                    mat-icon-button
                    type="button"
                    (click)="limpiarProximaCita()"
                    matTooltip="Quitar fecha"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                }
                <mat-datepicker-toggle matIconSuffix [for]="pickerCita"></mat-datepicker-toggle>
                <mat-datepicker #pickerCita></mat-datepicker>
                <!-- <mat-hint>Opcional</mat-hint> -->
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Motivo de la próxima consulta</mat-label>
                <input
                  matInput
                  maxlength="200"
                  placeholder="Ej. Revisión de resultados de laboratorio"
                  formControlName="motivoProximaCita"
                />
                <mat-hint>{{
                  recetaForm.get('proximaCita')?.value ? '' : 'Primero selecciona la fecha'
                }}</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full">
                <mat-label>Metas</mat-label>
                <textarea
                  matInput
                  rows="3"
                  placeholder="Metas para el paciente..."
                  formControlName="metas"
                ></textarea>
                <!-- <mat-hint>Opcional</mat-hint> -->
              </mat-form-field>

              <mat-form-field appearance="outline" class="full">
                <mat-label>Objetivos</mat-label>
                <textarea
                  matInput
                  rows="3"
                  placeholder="Objetivos del tratamiento..."
                  formControlName="objetivos"
                ></textarea>
                <!-- <mat-hint>Opcional</mat-hint> -->
              </mat-form-field>
            </div>

            <div class="acciones-paso">
              <button mat-flat-button type="button" class="add-boton" matStepperPrevious>
                <mat-icon>arrow_back</mat-icon>
                Anterior
              </button>

              <button mat-flat-button type="button" class="add-boton" (click)="generarPDF()">
                <mat-icon>picture_as_pdf</mat-icon>
                Generar receta y finalizar consulta
              </button>
            </div>
          </div>
        </form>
      </mat-step>
    </mat-stepper>

    <!-- <div class="stepper-footer">
      <button
        mat-button
        type="button"
        class="btn-anterior"
        [disabled]="stepper.selectedIndex === 0"
        (click)="stepper.previous()"
      >
        Anterior
      </button>

      <button
        mat-flat-button
        type="button"
        class="btn-siguiente"
        [disabled]="stepper.selectedIndex === stepper.steps.length - 1"
        (click)="stepper.next()"
      >
        Siguiente
      </button>
    </div> -->
  </div>
}
